<template>
  <div>小科金融</div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped></style>
